var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginBox"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.test}},[_vm._v("测 试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }